import { Fragment } from 'react';
/**
 * Ensure only valid prop "children" is passed to Fragment
 */
export function FragmentWithoutProps(props) {
    const { children } = props;
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <Fragment>{children}</Fragment>;
}
